    <!--begin::Main-->
    <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <!--begin::Content wrapper-->
        <div class="d-flex flex-column flex-column-fluid">

            <!--begin::Toolbar-->
            <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
                <!--begin::Toolbar container-->
                <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
                    <!--begin::Page title-->
                    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <!--begin::Title-->
                     <div class="d-flex align-items-center">
                        <h1 class="page-heading"><svg width="42" height="27" viewBox="0 0 42 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g filter="url(#filter0_d_651_309)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3028 5.08326C31.7505 5.08326 31.3028 5.53097 31.3028 6.08326V17.5453H27.3636V0.999999C27.3636 0.447714 26.9158 0 26.3636 0H23.9696C23.4173 0 22.9696 0.447715 22.9696 1V17.5453H19.0304V11.5537C19.0304 11.0014 18.5827 10.5537 18.0304 10.5537H15.6364C15.0842 10.5537 14.6364 11.0014 14.6364 11.5537V17.5453H10.6913V8.07453C10.6913 7.52224 10.2436 7.07453 9.69133 7.07453H7.29738C6.74509 7.07453 6.29738 7.52224 6.29738 8.07453V17.5453H4V19H38V17.5453H35.7085V6.08326C35.7085 5.53097 35.2608 5.08326 34.7085 5.08326H32.3028Z" fill="#265D91"/>
                            </g>
                            <defs>
                            <filter id="filter0_d_651_309" x="0" y="0" width="42" height="27" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                            <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                            <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                            <feOffset dy="4"/>
                            <feGaussianBlur stdDeviation="2"/>
                            <feComposite in2="hardAlpha" operator="out"/>
                            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                            <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_651_309"/>
                            <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_651_309" result="shape"/>
                            </filter>
                            </defs>
                            </svg>
                            
                            
                            Evaluation
                        </h1>
                            <!--begin::Menu-->
                     </div>
                        <!--end::Title-->
                        <!--begin::Breadcrumb-->
                        <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">
                                <a routerLink="/accueil" class="text-muted ">Accueil</a>
                              </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item">
                                <span class="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <!--end::Item-->
                            <!--begin::Item-->
                            <li class="breadcrumb-item text-muted">Evaluation</li>
                            <!--end::Item-->
                        </ul>
                        <!--end::Breadcrumb-->
                    </div>
                    <!--end::Page title-->
                    <!--begin::Actions-->

                    <!--end::Actions-->
                </div>
                <!--end::Toolbar container-->
            </div>
            <!--end::Toolbar-->
         
            <!--begin::Content-->

            <div id="kt_app_content" class="app-content flex-column-fluid mb-4">
                <!--begin::Content container-->
                <div id="kt_app_content_container" class="app-container container-fluid">
                    <!--begin::Card-->
                    <div class="card pb-10 pt-10">
                     
                        <!--begin::Card header-->
                        <div class="d-flex flex-wrap my-1 header-grid">
                            <div class="section_title">
                                <h1 class="section-heading my-0">Créer une évaluation</h1>
                               </div>
                           <div class="add-template">
                            

                           </div>
                         
                        </div>
                     
                        <!--end::Card header-->
                        <!--begin::Card body-->
                        <div class="card-body pt-15" [formGroup]="templateForm">
                            <div class="content" >
                                <div class="card-body pt-3">
                                    <!--begin::Table-->
                                  <div class="bloc-input mb-10">
                                    <label for="nom" class="mb-2 required">Nom d'evaluation</label>
                                    <input type="text"formControlName="name" name="nom" id="nom" class="form-control" placeholder="Nom d'evaluation">
                                    <div *ngIf="
                                    templateForm.get('name')?.hasError('required') &&
                                    templateForm.get('name')?.touched
                                  " class="text-danger">
                                  Le champ "Nom d'evaluation" est obligatoire .
                                </div>
                                  </div>
                         
                  
                                  <div class="bloc-input mb-10">
                                    <label for="type" class="mb-2 required">Type</label>
                                    <ng-select formControlName="type" [items]="type" bindLabel="name" [notFoundText]="'Aucun élément trouvé'" bindValue="id" [(ngModel)]="templateForm.value.type" [placeholder]="'type'" autoComplete></ng-select>
           <div *ngIf="
                                  templateForm.get('type')?.hasError('required') &&
                                  templateForm.get('type')?.touched
                                " class="text-danger">
                                Le champ "Type" est obligatoire .
                              </div>
                                  </div>
                         
                                  <div class="card-footer mx-5">
                                    <div class="actions">
                                        <a href="#" class="annuler" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()" style="cursor: pointer;">Annuler</a>
                                        <button class="confirmer"  (click)="createChapitre()" style="cursor: pointer;">Confirmer</button>
                                    </div>
                                </div>
                               
                                    <!--end::Table-->
                                </div>
                            </div>


                    
                            <!--end::Table-->
                        </div>
                        <!--end::Card body-->
                    </div>
                    <!--end::Card-->
                    <!--begin::Modals-->
                    <!--begin::Modal - Customers - Add-->
              
                    <!--end::Modal - Customers - Add-->
                    <!--begin::Modal - Adjust Balance-->
                
                    <!--end::Modal - New Card-->
                    <!--end::Modals-->
                </div>
                <!--end::Content container-->
            </div>
            <!--end::Content-->
        </div>
        <!--end::Content wrapper-->
        <!--begin::Footer-->

        <!--end::Footer-->
    <!--end:::Main-->
    </div>
    <script src="./assets/js/custom/apps/projects/settings/settings.js"></script>
    <script src="./assets/js/widgets.bundle.js"></script>
    <script src="./assets/js/custom/widgets.js"></script>
    <script src="./assets/js/custom/apps/chat/chat.js"></script>
    <script src="./assets/js/custom/apps/ecommerce/customers/listing/listing.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/add.js"></script>
		<script src="./assets/js/custom/apps/ecommerce/customers/listing/export.js"></script>
        <div class="modal fade" id="ajouter" tabindex="-1" aria-hidden="true">
            <!--begin::Modal dialog-->
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <!--begin::Modal content-->
                <div class="modal-content pt-5  pb-15">
                    <!--begin::Modal header-->
                    <div class="modal-header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bold">Ajouter question</h2>
                        <!--end::Modal title-->
                        <!--begin::Close-->
                        <div id="kt_customers_export_close" class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close">
                            <i class="ki-duotone ki-cross fs-1">
                                <span class="path1"></span>
                                <span class="path2"></span>
                            </i>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <!--begin::Modal body-->
                    <div class="modal-body mx-5" [formGroup]="questionForm">
                      <div class="bloc-input mb-5">
                        <label for="nom" class="mb-2">Ajouter question</label>
                        <input type="text" formControlName="question" name="question" id="question" class="form-control mb-3">
                      </div>
                      <div class="bloc-input mb-5">
                        <label for="bloc" class="mb-2">Bloc</label>
                        <ng-select
                        formControlName="chapter_eval_id"
                        [items]="chapitreList"
                        bindLabel="name"
                        bindValue="id"
                        [placeholder]="'Sélectionner un chapitre'"
                        autoComplete
                      ></ng-select>   
                      </div>
                      <div class="choose mb-5">
                        <span>Type de réponse</span>
                        <div class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" 
                            formControlName="typeResponse" value="1" id="noteRadio"/>
                            <label class="form-check-label" for="noteRadio">
                              Note / 5
                            </label>
                          </div>
                          
                          <div class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="radio" formControlName="typeResponse" value="2" id="commentRadio"/>
                            <label class="form-check-label" for="commentRadio">
                              Commentaire
                            </label>
                          </div>
                    </div>
                    </div>
                    <div class="card-footer mx-5">
                        <div class="actions">
                            <a href="#" class="annuler" data-bs-dismiss="modal" aria-label="Close">Annuler</a>
                            <a class="confirmer" (click)="createQuestion()">Confirmer</a>
                        </div>
                    </div>
                    <!--end::Modal body-->
                </div>
                <!--end::Modal content-->
            </div>
            <!--end::Modal dialog-->
        </div>